import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  createLeafWareHouseItem,
  getAllLeafWareHouseItems,
  getDataForEdit,
  updateLeafWareHouseItem,
  deleteLeafWareHouseItem,
} from "../../store/LeafWareHouse/LeafWareHouseApi";

import { leafWareHouseSliceAction } from "../../store/LeafWareHouse/LeafWareHouseSlice";
import { headTitle } from "../../utility/GetTableListName";

import MainComponent from "../../components/Base/MainComponent";
//importing constant form option to create form input
import { FormOptionsLeafWareHouse } from "../../ConstantData/FormOptions";
//importing inital form data to store value state
import { InitialLeafWareHouseFormData } from "../../ConstantData/InitialData";
import { ErrorLeafWareHouseFormData } from "../../ConstantData/ErrorOption";
function LeafWareHouse() {
  const dispatch = useDispatch();
  useEffect(() => {
    // dispatch(getAllLeafWareHouseItems()); //initial list data
  }, []);
  const isSuccess = useSelector((state) => state.applevel.isSuccess);

  const leafWareHouseList = useSelector(
    (state) => state.leafwarehouse.leafWareHouseList
  ); //store user list
  const InitialFormDataStore = useSelector(
    (state) => state.leafwarehouse.initialData
  );
  const leafWareHouseEditData = useSelector(
    (state) => state.leafwarehouse.dataEdit
  );

  let leafWareHouseFormError = useSelector(
    (state) => state.leafwarehouse.errorData
  );
  let isError = useSelector((state) => state.leafwarehouse.isError);
  leafWareHouseFormError = {
    ...ErrorLeafWareHouseFormData,
    ...leafWareHouseFormError,
  };
  let newFormOptionsUser = JSON.parse(JSON.stringify(FormOptionsLeafWareHouse));

  const headTitleLabel = headTitle(FormOptionsLeafWareHouse, [
    "Name",
    "Address",
    "Contact Number",
  ]); //array is field that is included in list heading

  return (
    <MainComponent
      InitialFormData={InitialLeafWareHouseFormData}
      createFun={createLeafWareHouseItem} //create function coming from store
      updateFun={updateLeafWareHouseItem} //update function coming from store
      getDataForEdit={getDataForEdit} //edit function coming from store
      delteFun={deleteLeafWareHouseItem}
      FormOptions={newFormOptionsUser}
      OptionName="Create Leaft Ware House"
      OptionNameList="Leaf Ware House"
      generalList={leafWareHouseList}
      headTitle={headTitleLabel}
      EditData={leafWareHouseEditData}
      ErrorData={leafWareHouseFormError}
      isError={isError}
      InitialFormDataStore={InitialFormDataStore}
      setErrorData={leafWareHouseSliceAction.setErrorData}
      isNotDeleteBtn={false}
      isSuccess={isSuccess}
    />
  );
}

export default LeafWareHouse;
